// extracted by mini-css-extract-plugin
export default {"todo":"Todo_todo__KBW37","done":"Todo_done__G-cRj","todo-title":"Todo_todo-title__litPY","todo-header":"Todo_todo-header__BPmfs","todo-footer":"Todo_todo-footer__Kau2L"};